import { fetchCountries } from './asyncThunk';
import { getListSlice, initialListState } from '../getListSlice';
import { IListState } from '../types';
import { ICountry } from '../../../api/base/Countries/types';

export type ICountriesState = IListState<ICountry>;

const initialState: ICountriesState = { ...initialListState };

const countriesSlice = getListSlice({
  moduleName: 'countries',
  fetchDataThunk: fetchCountries,
  initialState,
});

export const countriesReducer = countriesSlice.reducer;
